module.exports = __webpack_public_path__ + "img/icon.58e08a3e.png";